import script from "./SystemName.vue?vue&type=script&setup=true&lang=js"
export * from "./SystemName.vue?vue&type=script&setup=true&lang=js"

import "./SystemName.vue?vue&type=style&index=0&id=a5684ff4&scoped=true&lang=css"

import exportComponent from "/Users/Ios/Documents/project/FrontEnd/wk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a5684ff4"]])

export default __exports__